import React from 'react';
import { Linkedin, Facebook, Mail } from 'lucide-react';
import { RedditIcon } from '@/components/icons/RedditIcon';

export const PLATFORM_INFO = {
  linkedin: { 
    name: 'LinkedIn', 
    color: 'bg-blue-600', 
    icon: <Linkedin size={20} />, 
    status: 'coming_soon',
    direction: 'Craft a professional post for LinkedIn, highlighting the key insights and business value of the article.'
  },
  reddit: { 
    name: 'Reddit', 
    color: 'bg-orange-600', 
    icon: <RedditIcon className="w-5 h-5 text-white" />, 
    status: 'coming_soon',
    direction: 'Create a post for Reddit. Use a casual and engaging tone. Ask a question to spark discussion in the comments.'
  },
  twitter: { 
    name: 'Twitter/X', 
    color: 'bg-black', 
    icon: '𝕏', 
    status: 'coming_soon',
    direction: 'Draft a tweet for Twitter/X. Keep it concise and punchy, using relevant hashtags to maximize reach.'
  },
  facebook: { 
    name: 'Facebook', 
    color: 'bg-blue-500', 
    icon: <Facebook size={20} />, 
    status: 'coming_soon',
    direction: 'Write a Facebook post. Make it friendly and approachable, and encourage followers to share their thoughts.'
  },
  whatsapp: { 
    name: 'WhatsApp', 
    color: 'bg-green-600', 
    icon: '💬', 
    status: 'coming_soon',
    direction: 'Write a WhatsApp message to share with contacts. Keep it short and include a clear call-to-action.'
  },
  email: { 
    name: 'Email', 
    color: 'bg-purple-600', 
    icon: <Mail size={20} />, 
    status: 'coming_soon',
    direction: 'Compose an email to share with colleagues or contacts. Include a subject line and professional body text.'
  },
};

